import styled from 'styled-components';

import colors from 'themes/Main';

const { white, darkBlue, gray01, gray03 } = colors;

export const Container = styled.div`
  z-index: 20;
  position: absolute;
  bottom: -120%;
  right: ${({ position }) => (position === 'left' ? '25px' : '')};
  left: ${({ position }) => (position === 'right' ? '25px' : '')};
  display: none;
  width: 250px;
  padding: 16px;
  min-height: 80px;
  height: auto;
  background-color: ${white};
  border-radius: 4px;
  border: 1px solid rgba(215, 220, 230, 0.4);
  box-shadow: 0px 7px 8px rgba(215, 220, 230, 0.2),
    0px 5px 22px rgba(215, 220, 230, 0.12),
    0px 12px 17px rgba(215, 220, 230, 0.14);
`;

export const Head = styled.p`
  padding-bottom: 8px;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 700;
  color: ${gray03};
  text-transform: uppercase;
  border-bottom: 1px solid rgba(0, 0, 0, 0.035);
`;

export const Content = styled.div`
  p {
    width: 100% !important;
    padding: 0;
    margin-bottom: 0;
    font-size: 14px;
    line-height: 21px;
    font-weight: 400;
    color: ${gray01};
  }

  span {
    font-weight: 700;
    color: ${darkBlue};
  }
`;
